// Platform metrics surfaced across the marketing site (hero stats, footer,
// about, marketplace, etc.). Single source of truth — every consumer reads
// from here, so update numbers in ONE place.
//
// ⚠️ PROVISIONAL — pending real analytics. Only TRAINERS ("150+ early adopter
// coaches") is a figure we stand behind today. The rest are conservative
// early-stage placeholders, deliberately deflated from earlier inflated claims
// (was: CLIENTS 1,500+, WORKOUTS 10,000+, RATING 4.9★, HOURS_SAVED 15+).
// Replace each with a verified number from production/app-store data before
// leaning on it in campaigns.
//
// RATING and HOURS_SAVED were removed on 2026-09-23 (see
// claude-work-log/ for the competitor-landscape review that flagged them):
// there is no real app-store rating to cite yet, and "hours saved" was never
// measured. Do not reintroduce either without a real source — a genuine
// App Store / Play Store rating, or a completed timing study.
//
// 2026-10-12: CLIENTS / WORKOUTS / CITIES / COUNTRIES / DOWNLOADS removed. None had a source,
// and Play Store showed 100+ (client) and 50+ (coach) downloads, not 500+. Stat tiles now use
// PRODUCT_FACTS (things that are true of the product) instead of traction numbers.
export const PLATFORM_METRICS = {
  TRAINERS: '150+',      // confirmed by the team — early-adopter coach count (232 active coach accounts on 2026-10-12)
};

/** Verifiable product facts for stat tiles. Keep in step with pricing and the apps. */
export const PRODUCT_FACTS = {
  COACH_PRO_USD: '$19',  // Coach Pro, unlimited clients (₹499 in India)
  TRIAL: '30 days',      // free trial, 1 client, no card
  APP_LANGUAGES: '11',   // client app language options
  SPECIALTIES: '20',     // TrainerSpecialty enum in tzilla-be
};
